import { render, staticRenderFns } from "./EnviarPedido.vue?vue&type=template&id=9ad5b3b0&scoped=true"
import script from "./EnviarPedido.vue?vue&type=script&lang=js"
export * from "./EnviarPedido.vue?vue&type=script&lang=js"
import style0 from "./EnviarPedido.vue?vue&type=style&index=0&id=9ad5b3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad5b3b0",
  null
  
)

export default component.exports